export const FARM_ZONES = ['A', 'B', 'C', 'TEST'];

/**
 * 布局參考：docs/雞場統計_Farm efficeney 20260418_26616.xlsx → sheet【雞場 Farm】
 * - TEST 在 B5、B6 後方（獨立一列，對齊 B5/B6 區塊上方）
 * - C9 於 B3 列、地磅欄位（與 B3 對齊）
 */
export const FARM_MAP_ROWS = [
  {
    testRow: true,
    bArea: 'TEST',
  },
  {
    a: 'A4',
    bArea: ['B5', 'B6'],
    cMain: 'C5',
    cExt: 'C6',
  },
  {
    landmark: '農舍',
    bArea: 'B4',
    cMain: 'C4',
    cExt: 'C7',
  },
  {
    a: 'A3',
    bArea: 'B3',
    center: 'C9',
    cMain: 'C3',
    cExt: 'C8',
  },
  {
    a: 'A2',
    bArea: 'B2',
    cMain: 'C2',
  },
  {
    a: 'A1',
    landmark: '魚池',
    bArea: 'B1',
    center: '地磅',
    cMain: 'C1',
    cExt: '農舍',
  },
];
